import { useTranslation } from 'react-i18next';
import { useIntegrationsStatusContext } from '../context/IntegrationsStatusContext';

interface StepValidationResult {
    isValid: boolean;
    message?: string;
    tooltip?: string;
}

export const useStepValidation = () => {
    const { t } = useTranslation();
    const { integrations, isLoading } = useIntegrationsStatusContext();

    const validateStep1ToStep2 = (): StepValidationResult => {
        // Check if user has at least one integration AND has recent sync
        const hasIntegrations = integrations && integrations.length > 0;
        
        let hasRecentSync = false;
        if (hasIntegrations) {
            const twentyFourHoursAgo = Date.now() - (24 * 60 * 60 * 1000);
            hasRecentSync = integrations.some(integration => {
                if (!integration.endTime) return false;
                // endTime is a timestamp in seconds, convert to milliseconds
                const endTimeMs = integration.endTime * 1000;
                return endTimeMs > twentyFourHoursAgo;
            });
        }

        if (!hasIntegrations || !hasRecentSync) {
            return {
                isValid: false,
                message: t('flow.validation.requirements'),
                tooltip: t('flow.validation.requirements')
            };
        }

        return {
            isValid: true
        };
    };

    const validateStep2ToStep3 = (): StepValidationResult => {
        // TODO: Add validation logic for Smart Check completion
        // For now, always allow progression from step 2 to 3
        return {
            isValid: true
        };
    };

    return {
        validateStep1ToStep2,
        validateStep2ToStep3,
        isLoading
    };
};